import { render } from "./orders.vue?vue&type=template&id=d333ee8c&scoped=true"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"

import "./orders.vue?vue&type=style&index=0&id=d333ee8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d333ee8c"

export default script